<template>
  <div style="height: 100%">
    <el-scrollbar style="height: 100%; overflow-x: hidden" ref="scrollbar">
      <el-skeleton
        v-if="!articleDetail.title"
        :rows="6"
        animated
        style="padding-bottom: 20px"
      />

      <div v-else class="article-detail">
        <h1>{{ articleDetail.title }}</h1>
        <div class="info">
          <div>
            <span class="tag" v-if="articleDetail.class1">{{
              articleDetail.class1
            }}</span>
            <span class="time">{{ articleDetail.papername | formatPaperName }}</span>
            <span v-if="articleDetail.updatetime">{{
              formatDate(articleDetail.updatetime)
            }}</span>
            <el-divider direction="vertical"></el-divider>
            <span class="heat" v-if="articleDetail.degree"
              >热度<i>{{
                parseFloat(articleDetail.degree).toFixed(2)
              }}</i></span
            >
          </div>
          <div class="info-link">
            <a :href="articleDetail.url" target="_blank"
              ><i class="el-icon-connection"></i>查看原文</a
            >
          </div>
        </div>

        <div class="text" v-html="articleDetail.contenttxt"></div>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import { formatPaperName } from "@/filters/index.js";

export default {
  filters: {
    formatPaperName
  },
  props: ["articleDetail"],
  data() {
    return {
      InfoDialog: false
    };
  },
  activated() {},
  watch: {
    articleDetail: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.$refs.scrollbar.wrap.scrollTop = 0;
          setTimeout(() => {
            this.scrollToHighlight();
          }, 1000);
        }
      },
      deep: true
    }
  },
  created() {},
  mounted() {
    // window.scrollTo(0, 0);

    this.$nextTick(() => {
      this.$refs.scrollbar.wrap.scrollTop = 0;
      setTimeout(() => {
        this.scrollToHighlight();
      }, 1000);
    });
  },
  methods: {
    scrollToHighlight() {
      // 确保内容已经渲染完毕
      const highlightElement = this.$el.querySelector(".text .highlight");
      if (highlightElement) {
        this.$refs.scrollbar.$refs.wrap.scrollTop =
          highlightElement.offsetTop - 6;
        // 或者使用原生的 scrollIntoView 方法
        // highlightElement.scrollIntoView({ behavior: 'smooth' });
      }
    },
    formatDate(time) {
      // 截取时间，不需要毫秒
      return time.substring(0, 19);
    },

    jumpTo(url) {
      window.open(url);
    },

    openArticleInfo() {
      this.InfoDialog = true;

      setTimeout(() => {
        this.bar(); // 正面百分比进度条
        this.barEcharts();
      }, 500);
    },

    onClickOutside() {
      // 在这里处理点击区域以外的事件响应
      this.InfoDialog = false;
      console.log(this.InfoDialog);
    },

    bar() {
      this.$nextTick(() => {
        let progressBar = this.$refs.bar;
        progressBar.style.width = this.toPercent(this.articleDetail.videosize);
        this.val = this.toPercent(this.articleDetail.videosize);

        let progressTip = this.$refs.tip1;
        progressTip.style.left = this.toPercent(this.articleDetail.videosize);
      });
    },
    // 转换为百分比
    toPercent(point) {
      var str = (point / 100).toFixed(2) + "%";
      return str;
    },

    // barEcharts 图表数据
    barEcharts() {
      if (this.optionBar.series[0].data == "") {
        this.$nextTick(() => {
          for (let i = 0; i < this.articleDetail.emoTags.length; i++) {
            this.optionBar.xAxis.data.push(this.articleDetail.emoTags[i].label);
            this.optionBar.series[0].data.push(
              this.articleDetail.emoTags[i].value
            );
          }
          this.$refs.chart.drawChart();
        });
      } else {
        this.$nextTick(() => {
          this.optionBar.xAxis.data = [];
          this.optionBar.series[0].data = [];
          for (let i = 0; i < this.articleDetail.emoTags.length; i++) {
            this.optionBar.xAxis.data.push(this.articleDetail.emoTags[i].label);
            this.optionBar.series[0].data.push(
              this.articleDetail.emoTags[i].value
            );
          }
          this.$refs.chart.drawChart();
        });
      }
    }
  },

  directives: {
    "click-outside": {
      bind(el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          // 判断是否在元素内部点击
          if (!(el == event.target || el.contains(event.target))) {
            // 如果不是，则触发回调函数
            vnode.context[binding.expression](event);
          }
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
      },
      unbind(el) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.article-detail {
  width: 100%;
  margin: 0 auto;
  position: relative;
  padding: 0 20px;
  h1 {
    font-size: 24px;
    color: var(--text-1);
  }
  .sidebar {
    position: absolute;
    left: -50px;
    top: 55px;
    ul {
      margin: 0;
      padding: 0;
      li {
        list-style-type: none;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 20px;
        cursor: pointer;
        color: var(--text-3);
        i {
          font-size: 16px;
          margin-bottom: 5px;
        }
        span {
          font-size: 12px;
        }
        &:hover {
          color: var(--brand);
        }
      }
    }
  }
  .info {
    color: var(--text-3);
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    &-link {
      a {
        color: var(--text-3);
        &:hover {
          color: var(--brand);
        }
      }
    }
    span {
      // margin-right: 10px;
      &:nth-child(2) {
        flex: 1;
      }
    }
    i {
      margin-right: 5px;
    }
    .tag {
      background: rgba(62, 157, 211, 0.1);
      padding: 2px 4px;
      color: #3e9dd3;
      font-size: 12px;
      margin-right: 8px;
      border-radius: 0;
    }
    .time {
      margin-right: 5px;
    }
    .heat {
      // margin-left: 40px;
      i {
        font-style: normal;
        font-weight: bold;
        font-size: 15px;
        color: #fe2d46;
        margin-left: 6px;
      }
    }
  }
  .text {
    font-size: 17px;
    line-height: 1.6;
    color: var(--text-1);
    margin-top: 20px;
    padding-bottom: 260px;
    text-align: justify;
  }
  ::v-deep img {
    width: 100%;
    border-radius: 6px;
  }
  ::v-deep video {
    width: 100%;
    margin: 0 auto;
  }
}

.fn-info-dialog-enter-active {
  animation: fn-fade-in 0.3s;
}
.fn-info-dialog-leave-active {
  animation: fn-fade-in 0.3s reverse;
}
@keyframes fn-fade-in {
  0% {
    opacity: 0;
    transform: translateY(-4%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.articleInfoDialog {
  position: absolute;
  top: -6px;
  left: 50px;
  width: 460px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 6px 26px rgba(0, 0, 0, 0.1);
  padding: 0 40px 20px;
  z-index: 1;
  > div {
    .info-item:last-child {
      border-bottom: none;
    }
  }
  &::before {
    content: "";
    width: 0;
    height: 0;
    border-bottom: 6px solid transparent;
    border-right: 6px solid #fff;
    border-top: 6px solid transparent;
    position: absolute;
    left: -6px;
    top: 10px;
  }
}
@keyframes show {
  from {
    opacity: 0;
    top: -10px;
  }
  to {
    opacity: 1;
    top: -28px;
  }
}

.info-item {
  border-bottom: 1px dashed #dddddd;
  h5 {
    font-size: 16px;
    font-weight: 500;
    margin: 20px 0 10px;
    color: var(--text-2);
  }
  ul {
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    li {
      color: var(--text-3);
      background: #ecf4ff;
      font-size: 14px;
      padding: 4px 6px;
      border-radius: 2px;
      margin-right: 4px;
      margin-bottom: 10px !important;
      cursor: default !important;
      &:hover {
        color: var(--text-3) !important;
      }
    }
  }
}
</style>
